<!--Document format shown as result of document search-->

<template>
  <mdb-container v-if="!loading" class="animated bounce">
    <mdb-row class="my-3 default" >
      <mdb-col v-if="documents.length == 0" class="w-100">
        <h2><strong>No Documents Found</strong></h2>
      </mdb-col>
      <mdb-col v-else>
        <h2><strong>Search Results</strong></h2>
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col>
        <mdb-card-group>
          <mdb-card class="m-3" style="min-width: 200px;" v-for="(document, i) in documents" :key="i">
            <mdb-card-header class="text-left"><mdb-icon icon="file" class="pr-2"/>{{document.title}}</mdb-card-header>
            <mdb-card-body>
              <mdb-card-text class="p-2">{{document.description}}</mdb-card-text> 
              <a :href="document.doc_file.meta.download_url">
                <mdb-btn class="btn-sm" color="primary">Download</mdb-btn>
              </a>
            </mdb-card-body>
          </mdb-card>
        </mdb-card-group>
      </mdb-col>
    </mdb-row> 
  </mdb-container>
</template>

<script>
import { mdbCard, mdbCardBody, mdbCardText, mdbCardHeader, mdbBtn, mdbIcon, mdbContainer, mdbRow, mdbCol, mdbCardGroup } from "mdbvue";
import axios from "axios";
import api from "@/api"
import _ from "lodash";
export default {
  name: "DepartmentDocumentSearch",
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbCardHeader,
    mdbBtn,
    mdbIcon,
    mdbContainer, 
    mdbRow,
    mdbCol,
    mdbCardGroup
  },
  props: {
    slug: {
      type: [String, Number]
    },
    type: {
      type: [String],
      default: "departments.DepartmentDocument"
    },
    fields: {
      type: [String],
      default:
        "title,content,categories,tags,blog_authors,custom_title,banner_image,parent_id"  //Well some of these are definitely not right...
    },
    searchQuery: {
      type: [String]
    },
    descendant_of: {
      type: [Number]
    }
  },
  data() {
    return {
      loading: true,
      documents: false
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("type", this.type);
      params.append("fields", "*");
      params.append("search", this.searchQuery);
      params.append("descendant_of", this.descendant_of);
      return params;
    }
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        api.get("pages/", {
          params: this.axiosParams
        })
        .then(response => {
          this.documents = response.data.items;     
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    slug: function() {
      // watch it
      this.getDataDebounced();
    },
    searchQuery: function() {
      this.getDataDebounced();
    }
  },
  mounted() {
    this.getData();
  },
  created() {
    this.getDataDebounced = _.debounce(this.getData, 500);
  },
};
</script>